import React from "react";
import { Box, Typography, Paper } from "@mui/material";

interface FormSectionProps {
  title?: string;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ title, children }) => (
  <Paper className="mb-4 shadow-sm border-0">
    <Box className="px-3 pt-4 pb-5">
      {title && (
        <Typography
          variant="h6"
          className="fw-bold mb-3"
          sx={{ color: "rgba(13,44,90,1)" }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  </Paper>
);

export default FormSection;
